export default "__VITE_ASSET__D6M4Lx5e__"